/**
 * Get Dashboard Stats Use Case
 * Obtém estatísticas gerais do dashboard
 */
import { DashboardRepository } from '../repositories/dashboard_repository';
import { DashboardStatsEntity } from '../entities/dashboard_entity';

export class GetDashboardStatsUseCase {
  constructor(private repository: DashboardRepository) {}

  async execute(): Promise<DashboardStatsEntity> {
    console.log('📊 UseCase: Executando obtenção de estatísticas...');
    
    try {
      const stats = await this.repository.getStats();
      console.log('✅ UseCase: Estatísticas obtidas com sucesso', stats);
      return stats;
    } catch (error) {
      console.error('❌ UseCase: Erro ao obter estatísticas', error);
      throw error;
    }
  }

  async executeByPeriod(startDate: Date, endDate: Date): Promise<DashboardStatsEntity> {
    console.log('📅 UseCase: Executando obtenção de estatísticas por período...', { startDate, endDate });
    
    try {
      const stats = await this.repository.getStatsByPeriod(startDate, endDate);
      console.log('✅ UseCase: Estatísticas por período obtidas com sucesso', stats);
      return stats;
    } catch (error) {
      console.error('❌ UseCase: Erro ao obter estatísticas por período', error);
      throw error;
    }
  }

  async refresh(): Promise<void> {
    console.log('🔄 UseCase: Executando atualização de cache...');
    
    try {
      await this.repository.refreshStats();
      console.log('✅ UseCase: Cache atualizado com sucesso');
    } catch (error) {
      console.error('❌ UseCase: Erro ao atualizar cache', error);
      throw error;
    }
  }
}
